<template>
  <portlet
          :icon="'fad fa-user-injured'"
          :title="'Ziek meldingen'"
          :actionsBlock="true">
    <template slot="portletBody">
      <form @submit.prevent="addCandidateSickDays();">
        <div class="row">
          <div class="form-group col-6 col-lg-3">
            <label for="sickLeave-startDate">Begin datum</label>
            <datepicker
                    name="startDate"
                    :language="nl"
                    id="sickLeave-startDate"
                    v-model="sickLeave.startDate"
                    :fullMonthName="true"
                    format="dd-MM-yyyy"
                    input-class='form-control'
                    :calendar-button="true"
                    :calendar-button-icon="'far fa-calendar-alt'"
                    :disabled-dates="disabledStartDates"
            >
            </datepicker>
          </div>
          <div class="form-group col-6 col-lg-3">
            <label for="sickLeave-endDate">Einddatum</label>
            <datepicker
                    name="endDate"
                    :language="nl"
                    id="sickLeave-endDate"
                    v-model="sickLeave.endDate"
                    :fullMonthName="true"
                    format="dd-MM-yyyy"
                    input-class='form-control'
                    :calendar-button="true"
                    :calendar-button-icon="'far fa-calendar-alt'"
                    :clear-button="true"
                    :clear-button-icon="'far fa-times'"
                    :disabled-dates="disabledEndDates"

            >
            </datepicker>
          </div>
          <div class="col-sm-2 sickDays-save">
            <button class="btn btn-primary">Nieuwe ziekmelding</button>
          </div>
        </div>
      </form>
      <datatables
              :tableClass="tableClass"
              v-if="sickDaysList.length && renderedComponent"
              :rows="sickDaysList"
              :columns="columns"
              tableID="sickDaysList"
              :tableInitOptions="tableInitOptions"
              routerLinkClass="dt-router-link"
              :deleteFunction="deleteSickDays"
              deleteClass="delete"
              :getDataClass="'get-data'"
              @rowSelected="rowSelected"
      ></datatables>
      <edit-candidate-sick-days
              v-if="editSickness"
              :title="'Ziek melding aanpassen'"
              :value="editSickness"
              :name="modalId"
              @saveChanges="editSickDays($event)"
      ></edit-candidate-sick-days>
    </template>
  </portlet>
</template>

<script>
  import {nl} from 'vuejs-datepicker/dist/locale';
  import editCandidateSickDays from "../../editCandidateSickDays";
  import {dataTables} from "../../../components/mixins/dataTables";
  import {swalModals} from "../../../components/mixins/swalModals.js";

  export default {
    mixins: [dataTables, swalModals],
    components: {editCandidateSickDays},
    props: ['candidateId'],
    data() {
      return {
        nl: nl,
        sickLeave: {
          startDate: null,
          endDate: null
        },
        editSickness: null,
        sickDays: [],
        endDateMissing: false,
        modalId: '',
        tableInitOptions: {
          order: [[0, "desc"]],
          lengthChange: false,
          searching: false,
        },
        columns: [
          {
            data: 'startDate', name: 'Begin datum', visible: true, searchable: true, responsivePriority: 1,
            render(data) {
              if (data) {
                return moment(data).format('DD-MM-YYYY')
              } else {
                return ''
              }
            }
          },
          {
            data: 'endDate', name: 'Einddatum', visible: true, searchable: true,
            render(data) {
              if (data) {
                return moment(data).format('DD-MM-YYYY')
              } else {
                return ''
              }
            }
          },
          {
            data: null, name: 'Dagen', visible: true, searchable: true,
            render(data) {
              const endDate = data.endDate ? moment(data.endDate) : moment();
              const startDate = moment(data.startDate);
              const days = moment.duration(endDate.endOf('day').diff(startDate.startOf('day'))).asDays();
              return Math.ceil(days)
            },
          },
          {
            data: null, name: 'Opties', orderable: false, responsivePriority: 2,
            render(data) {
              return '<i title="Datums aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>' +
                  '<a class="delete action-icon" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
            }
          },
        ]
      };
    },
    firestore() {
      return {
        sickDays: this.$FB.collection('candidates').doc(this.candidateId).collection('sickDays')
      }
    },
    methods: {
      rowSelected(value) {
        this.modalId = value.id;
        this.editSickness = {id: this.modalId, startDate: value.startDate, endDate: value.endDate};
        setTimeout(()=>{
          $(".modal").modal("show");
        },100)
      },



      checkIfCandidateIsSick(sickDaysList) {

        let isSick = false;
        let checkSicknessDate = false;

        sickDaysList.forEach(function (sickDays) {
          checkSicknessDate = moment(new Date()).isBetween(sickDays.startDate, sickDays.endDate);
          if ((checkSicknessDate) || moment().isSame(sickDays.startDate) || moment().isSame(sickDays.endDate)) {
            isSick = true
          }
        })

        let currentSickOpenEntry = _.find(sickDaysList, ['endDate', null]);

        if (currentSickOpenEntry) {
          checkSicknessDate = moment(new Date()).isAfter(currentSickOpenEntry.startDate);
          if ((checkSicknessDate) || (currentSickOpenEntry.startDate === new Date())) {
            isSick = true
          }
        }

        let id = this.candidateId
        this.$store.dispatch('candidates/set', {id, sick: isSick})

      },

      checkCurrentEntries() {

        let currentSickEntries = _.filter(this.sickDays, ['endDate', null]);
        let currentSickEntriesSameStartDate = _.filter(this.sickDays, ['startDate', moment(this.sickLeave.startDate).format('YYYY-MM-DD')]);
        if (!this.sickLeave.startDate) {
          this.$swal({
            title: "Begin datum niet ingevuld",
            html: 'Het is niet mogelijk om een lege begin datum in te vullen. Dit veld is verplicht.',
            type: "info",
            confirmButtonText: 'Oké',
            reverseButtons: true,
          }).then(() => {
            this.endDateMissing = false;
          })
        } else if (currentSickEntries.length && !this.sickLeave.endDate) {
          this.$swal({
            title: "Einddatum niet ingevuld",
            html: 'Het is niet mogelijk om een lege Einddatum in te vullen als deze al aanwezig is.',
            type: "info",
            confirmButtonText: 'Oké',
            reverseButtons: true,
          }).then(() => {
            this.endDateMissing = false;
          })
        } else if (currentSickEntriesSameStartDate.length) {
          this.$swal({
            title: "Begin datum al ingevuld",
            html: 'Selecteer een andere datum.',
            type: "info",
            confirmButtonText: 'Oké',
            reverseButtons: true,
          }).then(() => {
            this.endDateMissing = false;
          })

        } else {
          this.endDateMissing = true;
        }
      },

      addCandidateSickDays() {
        this.checkCurrentEntries();
        if (this.endDateMissing) {
          if (this.sickLeave.endDate !== null) {
            this.sickLeave.endDate = moment(this.sickLeave.endDate).format('YYYY-MM-DD')
          }

          this.$FB.collection('candidates').doc(this.candidateId).collection('sickDays').add({
            id: this.$FB.collection('candidates').doc(this.candidateId).collection('sickDays').doc().id,
            startDate: moment(this.sickLeave.startDate).format('YYYY-MM-DD'),
            endDate: this.sickLeave.endDate,
            createdBy: this.$store.getters.getUserData,
            department: this.$store.getters.getUserData.selectedDepartment
          }).then(() => {
            this.renderComponent();
            this.$toasted.global.successRequest({
              message: "Ziek melding aangemaakt"
            });
            this.checkIfCandidateIsSick(this.sickDaysList)
          }).catch(error => {
            this.$toasted.global.failedRequest();
          });
          this.$validator.reset();

          if (this.sickLeave.endDate != null) {

          }
          this.sickLeave.startDate = null;
          this.sickLeave.endDate = null;
          this.endDateMissing = false;
        }
      },

      editSickDays(sickDays) {

        var convertedEndDate = null;
        if (sickDays.endDate === null) {
          convertedEndDate = null
        } else {
          convertedEndDate = moment(sickDays.endDate).format('YYYY-MM-DD')
        }

        $(".modal").modal("hide");
        $(".modal-backdrop").remove();

        this.$FB.collection('candidates').doc(this.candidateId).collection('sickDays').doc(sickDays.id.toString()).update({
          startDate: moment(sickDays.startDate).format('YYYY-MM-DD'),
          endDate: convertedEndDate,
          updatedBy: this.$store.getters.getUserData
        }).then(() => {
          this.renderComponent();
          this.$toasted.global.successRequest({
            message: "Datum aangepast"
          });

          this.checkIfCandidateIsSick(this.sickDays)
        })

        if (sickDays.endDate !== null) {
          sickDays.endDate = moment(sickDays.endDate).format('YYYY-MM-DD')
        }
      },

      deleteSickDays(sickDays) {
        let name = '';
        let startDate = moment(sickDays.startDate).format('DD-MM-YYYY');
        if (sickDays.endDate) {
          let endDate = moment(sickDays.endDate).format('DD-MM-YYYY');
          name = startDate + ' - ' + endDate;
        } else {
          name = startDate;
        }
        this.swalDelete(name).then(result => {
          if (result.value) {
            this.$FB.collection('candidates').doc(this.candidateId).collection('sickDays').doc(sickDays.id).delete().then(() => {
              this.renderComponent();
              this.$toasted.global.successRequest({
                message: "Ziek dagen verwijderd"
              });
              this.checkIfCandidateIsSick(this.sickDaysList)
            });
          } else {
            return;
          }
        });

      }
    },
    computed: {
      disabledEndDates() {
        return {
          to: new Date(this.sickLeave.startDate),
          ranges: this.disabledDates
        }
      },
      disabledStartDates() {
        if (this.sickLeave.endDate !== null) {
          return {
            from: new Date(this.sickLeave.endDate),
            ranges: this.disabledDates
          }
        } else {
          return {
            ranges: this.disabledDates
          }
        }
      },

      disabledDates() {
        let ranges = []
        // Push every date into from, to in the range array
        _.each(this.sickDays, (dates) => {
          ranges.push(
              {
                from: new Date(dates.startDate),
                to: new Date(dates.endDate)
              })
        })

        return ranges

      },

      sickDaysList() {
        return _.orderBy(this.sickDays,
            ['endDate', object => moment(object.startDate, "DD-MM-YYYY").format('YYYYMMDD')], ['desc', 'asc']);
      },
    },
  };
</script>
